// React
import { PropsWithChildren } from "react"

// Components
import { Card } from "components"
import { AttachmentModal } from "../PurchaseOrder/components"

export function ActionButton(params: PropsWithChildren<{}>) {
  return (
    <Card>
      <Card.Body className="flex flex-col gap-5">
        <section className="flex flex-wrap justify-between gap-3">
          {params.children}
        </section>
      </Card.Body>
    </Card>
  )
}

function LeftSide() {
  return (
    <section className="flex flex-wrap gap-3">
      <AttachmentModal />
    </section>
  )
}

ActionButton.LeftSide = LeftSide